export default __webpack_public_path__ + "static/bo-b8d0a0859595b282788af4752e2b399c.svg";